"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.annualMileageToOptions = annualMileageToOptions;
exports.deriveExtraLinks = deriveExtraLinks;
exports.formatPercent = formatPercent;
exports.formatPrice = formatPrice;
exports.getCachedSelectModelAndTab = getCachedSelectModelAndTab;
exports.getComponentPageDataByResourceType = getComponentPageDataByResourceType;
exports.getDefaultValue = getDefaultValue;
exports.getExtraLinks = getExtraLinks;
exports.getQueryVariables = getQueryVariables;
exports.getQueryVariables2 = getQueryVariables2;
exports.getRaqParams = getRaqParams;
exports.getSelectedPaymentFrequencyLabel = getSelectedPaymentFrequencyLabel;
exports.getTaxesAndFeesSelection = getTaxesAndFeesSelection;
exports.getTermValue = getTermValue;
exports.getTotalTaxesAndFeesSelectedByCalculation = getTotalTaxesAndFeesSelectedByCalculation;
exports.isDownPaymentKey = isDownPaymentKey;
exports.isTradeInKey = isTradeInKey;
exports.parseGQLData = parseGQLData;
exports.parseTerms = parseTerms;
exports.stringsToOptions = stringsToOptions;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _constants = require("./constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable no-use-before-define */
/**
 * @typedef {{ value: string, default: Boolean }} TabOptionRaw
 * @typedef {{ value: Number, default: Boolean }} TabOption
 */

/**
 * formatPrice
 * @param {*} value
 * @param {String?} [currencyFormat="USD"]
 * @param {String?} localeCode
 * @param {Number?} decimalRange
 * @returns {String}
 */
function formatPrice(value, currencyFormat, localeCode, decimalRange) {
  if (currencyFormat === void 0) {
    currencyFormat = 'USD';
  }
  if (localeCode === void 0) {
    localeCode = 'en-US';
  }
  if (decimalRange === void 0) {
    decimalRange = 2;
  }
  var out = null;
  if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
    if (!Number.isNaN(+value)) {
      out = Intl.NumberFormat(localeCode, {
        style: 'currency',
        currency: currencyFormat,
        maximumFractionDigits: decimalRange,
        minimumFractionDigits: decimalRange
      }).format(value).replace(/\.00$/, '');
    }
  } else {
    out = Number(value).toFixed(decimalRange);
  }
  return out;
}

/**
 * formatPercent
 * @param {*} value
 * @param {String?} localeCode
 * @param {Number?} minDecimal
 * @param {Number?} maxDecimal
 * @returns {String}
 */
function formatPercent(value, localeCode, minDecimal, maxDecimal) {
  if (localeCode === void 0) {
    localeCode = 'en-US';
  }
  if (minDecimal === void 0) {
    minDecimal = 0;
  }
  if (maxDecimal === void 0) {
    maxDecimal = 2;
  }
  var out = null;
  if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
    if (!Number.isNaN(+value)) {
      out = Intl.NumberFormat(localeCode, {
        maximumFractionDigits: maxDecimal,
        minimumFractionDigits: minDecimal
      }).format(value) + '%';
    }
  } else {
    out = Number(value) + '%';
  }
  return out;
}
/**
 * @deprecated Use `stringsToOptions()` instead.
 */
function annualMileageToOptions(arr, indexSelected) {
  if (indexSelected === void 0) {
    indexSelected = 0;
  }
  return arr.reduce(function (options, value, index) {
    return [].concat(options, [{
      value: Number(value),
      "default": indexSelected && indexSelected > -1 ? index === indexSelected : index === 0
    }]);
  }, []);
}

/**
 * stringsToOptions
 * @param {{ items: String[], parser: Function?, defaultIndex?: Number }} strings
 * @returns {TabOption[]}
 */
function stringsToOptions(_ref) {
  var items = _ref.items,
    _ref$parser = _ref.parser,
    parser = _ref$parser === void 0 ? String : _ref$parser,
    defaultIndex = _ref.defaultIndex;
  return (items || []).reduce(function (options, value, index) {
    return [].concat(options, [{
      label: value,
      value: parser(value),
      "default": index === defaultIndex
    }]);
  }, []);
}

/**
 * getDefaultValue
 * @param {TabOption[]} items
 * @returns {TabOption | {}}
 */
function getDefaultValue(items) {
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }
  return (items.find(function (item) {
    return item["default"] === true;
  }) || {}).value;
}

/**
 * @deprecated This will be removed in the future
 * @param {TabOption[]} terms
 * @param {Number} defaultTerm
 * @returns
 */
function getTermValue(terms, defaultTerm) {
  return getDefaultValue(terms) || defaultTerm;
}

/**
 * parseTerms
 * @param {TabOptionRaw[]} terms
 * @returns {TabOption[]}
 */
function parseTerms(terms) {
  if (!Array.isArray(terms) || terms.length === 0) {
    return null;
  }
  var hasDefault = false;
  var parsedTerms = terms.map(function (term) {
    if (term["default"] === true || term["default"] === 'true') {
      hasDefault = true;
    }
    return _objectSpread(_objectSpread({}, term), {}, {
      value: Number(term.value)
    });
  });
  // Default to first term if no default provided
  if (!hasDefault) {
    parsedTerms[0]["default"] = true;
  }
  return parsedTerms;
}
function getQueryVariables(_ref2) {
  var variables = _ref2.variables,
    _ref2$inlineVariables = _ref2.inlineVariables,
    inlineVariables = _ref2$inlineVariables === void 0 ? {} : _ref2$inlineVariables,
    location = _ref2.location;
  var calcVehicle = (0, _get2["default"])(location, 'query.vehicle');
  var calcYear = (0, _get2["default"])(location, 'query.year');
  var calcFuelType = (0, _get2["default"])(location, 'query.fuelType');
  var calcModel = (0, _get2["default"])(location, 'query.model');
  var calcColour = (0, _get2["default"])(location, 'query.color');
  var paymentYear = (0, _get2["default"])(location, 'query.paymentYear');
  var datasetName = (0, _get2["default"])(location, 'query.datasetName');
  var isDefaultRate = inlineVariables.isDefaultRate,
    downPaymentAmount = inlineVariables.downPaymentAmount,
    financeTerm = inlineVariables.financeTerm,
    leaseTerm = inlineVariables.leaseTerm,
    rate = inlineVariables.rate,
    tradeInValue = inlineVariables.tradeInValue,
    annualMileage = inlineVariables.annualMileage,
    color = inlineVariables.color,
    _inlineVariables$exte = inlineVariables.exteriorColorCode,
    exteriorColorCode = _inlineVariables$exte === void 0 ? '' : _inlineVariables$exte,
    _inlineVariables$inte = inlineVariables.interiorColorCode,
    interiorColorCode = _inlineVariables$inte === void 0 ? '' : _inlineVariables$inte,
    _inlineVariables$pack = inlineVariables.packageCodes,
    packageCodes = _inlineVariables$pack === void 0 ? [] : _inlineVariables$pack,
    _inlineVariables$acce = inlineVariables.accessoryCodes,
    accessoryCodes = _inlineVariables$acce === void 0 ? [] : _inlineVariables$acce;
  var isUS = variables.market === 'us';
  var pathPrefix = "/" + variables.market + "/" + variables.language;
  var finalVariables = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, variables), downPaymentAmount && {
    downPaymentAmount: Number(downPaymentAmount)
  }), financeTerm && {
    financeTerm: Number(financeTerm)
  }), leaseTerm && {
    leaseTerm: Number(leaseTerm)
  }), paymentYear && {
    paymentYear: paymentYear.split(',').map(function (item) {
      return Number(item);
    })
  }), tradeInValue && {
    tradeInValue: Number(tradeInValue)
  }), annualMileage && {
    annualMileage: Number(annualMileage)
  }), rate && !isDefaultRate && {
    rate: Number(rate)
  }), isDefaultRate === false && {
    customerCash: false
  }), color && color.price && {
    exteriorColorPrice: Number(color.price.value)
  }), !(0, _isEmpty2["default"])(inlineVariables) && {
    selection: {
      vehicle: calcVehicle,
      year: Number(calcYear),
      fuelType: calcFuelType,
      model: calcModel,
      color: calcColour || exteriorColorCode,
      fabric: interiorColorCode,
      packages: packageCodes || [],
      accessories: accessoryCodes || []
    }
  });
  if (!finalVariables.path) {
    if (!(0, _get2["default"])(location, 'pathname') || (0, _get2["default"])(location, 'pathname') === '/iframe.html') {
      finalVariables.path = pathPrefix + "/buy/configure/" + (isUS ? 'ngc-demo' : 'configurator');
    } else {
      finalVariables.path = [pathPrefix, // Remove any trailing language
      "" + location.pathname.replace("/" + variables.language, '')].join('');
    }
  }
  if (!finalVariables.url) {
    if (isUS) {
      finalVariables.url = "/" + variables.language + "/payment-calculator";
    } else {
      finalVariables.url = pathPrefix + "/payment-calculator-form";
    }
  }
  if (!(0, _isEmpty2["default"])(inlineVariables) && (0, _get2["default"])(location, 'search')) {
    finalVariables.selection.url = "" + finalVariables.path + location.search;
  }
  if (datasetName) {
    finalVariables.datasetName = datasetName;
  }
  return finalVariables;
}
function getRaqParams(carData) {
  var derivedParams = ((0, _get2["default"])(carData, 'calculation.requestQuoteRedirectUrl') || '').split('?');
  if (derivedParams.length > 1) {
    return derivedParams[1];
  }
  if (!carData.calculation) {
    return {};
  }
  var _carData$query = carData.query,
    vehicle = _carData$query.vehicle,
    model = _carData$query.model,
    year = _carData$query.year,
    trim = _carData$query.trim;
  var _carData$calculation = carData.calculation,
    monthlyAmount = _carData$calculation.monthlyAmount,
    amountFinanced = _carData$calculation.amountFinanced,
    downPayment = _carData$calculation.downPayment,
    rate = _carData$calculation.rate,
    terms = _carData$calculation.terms;
  var cfMonthly = (0, _get2["default"])(monthlyAmount, 'displayValue') || '';
  var cfFinanced = (0, _get2["default"])(amountFinanced, 'displayValue') || '';
  var cfDownPayment = (0, _get2["default"])(downPayment, 'displayValue') || '';
  var term = terms != null && terms.length ? terms.find(function (x) {
    return x["default"];
  }).value : '';
  return "cf_vehicle=" + vehicle + "&cf_model=" + model + "&cf_year=" + year + "&cf_trim=" + trim + "&cf_type=" + carData.type + "&cf_monthlyPayment=" + cfMonthly + "&cf_amount=" + cfFinanced + "&cf_downPayment=" + cfDownPayment + "&cf_terms=" + term + "&cf_rateOfCustomer=" + rate;
}
function deriveExtraLinks(carData, linksData) {
  var raqParams = getRaqParams(carData);
  var raqUrl = linksData.clickShopEnabled ? linksData.cta2Link : linksData.cta2Link + "?" + raqParams;
  var extraLinks = {
    requestTestDrive: {
      label: linksData.cta1Label,
      url: linksData.cta1Link,
      openNewTab: linksData.cta1OpenNewTab
    },
    requestQuote: {
      label: linksData.cta2Label,
      url: raqUrl,
      priority: 'critical',
      openNewTab: linksData.cta2OpenNewTab
    }
  };
  return extraLinks;
}

/**
 * getQueryVariables2
 * @param {Object} query - Location query
 * @param {Object} options
 * @returns {Object}
 */
function getQueryVariables2(query, options) {
  var stateCode = options.globalLocation.stateCode;
  var additionalPriceGroup = options.additionalPriceGroup,
    formData = options.formData,
    selectedModel = options.selectedModel;
  var packagePrices = (0, _get2["default"])(additionalPriceGroup, 'package', 0);
  var exteriorColorPrice = (0, _get2["default"])(additionalPriceGroup, 'color', 0);
  var interiorColorPrice = (0, _get2["default"])(additionalPriceGroup, 'fabric', 0);
  var accessoriesPrice = (0, _get2["default"])(additionalPriceGroup, 'accessory', 0);
  var exteriorColorCode = (0, _get2["default"])(additionalPriceGroup, 'colorCode', '');
  var interiorColorCode = (0, _get2["default"])(additionalPriceGroup, 'fabricCode', '');
  var $defaultRate = formData.$defaultRate,
    downPaymentAmount = formData.downPaymentAmount,
    interestRate = formData.interestRate,
    isDefaultRate = formData.isDefaultRate,
    tradeInValue = formData.tradeInValue,
    financeTerm = formData.financeTerm,
    leaseTerm = formData.leaseTerm,
    leaseAnnualMileage = formData.leaseAnnualMileage,
    paymentModel = formData.paymentModel,
    financePaymentFrequency = formData.financePaymentFrequency,
    leasePaymentFrequency = formData.leasePaymentFrequency,
    includeTax = formData.includeTax,
    includeFee = formData.includeFee,
    rebates = formData.rebates;
  var variables = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    path: options.path,
    region: stateCode,
    market: options.market,
    language: options.language,
    zipCode: options.zipCode,
    exteriorColorPrice: exteriorColorPrice,
    interiorColorPrice: interiorColorPrice,
    packagePrices: packagePrices,
    accessoriesPrice: accessoriesPrice,
    downPaymentAmount: 0,
    tradeInValue: 0,
    downPaymentPerc: 0,
    financePaymentFrequency: financePaymentFrequency,
    leasePaymentFrequency: leasePaymentFrequency
  }, includeTax && {
    includeTax: true
  }), includeFee && {
    includeFee: true
  }), rebates && {
    rebates: rebates
  }), downPaymentAmount && {
    downPaymentAmount: Number(downPaymentAmount)
  }), financeTerm && {
    financeTerm: Number(financeTerm)
  }), leaseTerm && {
    leaseTerm: Number(leaseTerm)
  }), tradeInValue && {
    tradeInValue: Number(tradeInValue)
  }), typeof interestRate === 'number' && {
    buyRate: isDefaultRate ? $defaultRate : interestRate
  }), leaseAnnualMileage && {
    annualMileage: String(leaseAnnualMileage)
  });
  var packageCodes = (0, _get2["default"])(additionalPriceGroup, 'packageCodes');
  var accessoryCodes = (0, _get2["default"])(additionalPriceGroup, 'accessoryCodes');
  variables.selection = {
    vehicle: query.vehicle || query.paymentVehicle,
    year: Number(query.year || (selectedModel == null ? void 0 : selectedModel.modelYear)),
    fuelType: getFuelType(),
    model: query.model || (selectedModel == null ? void 0 : selectedModel.modelCode) || paymentModel,
    url: query.url,
    color: query.color || exteriorColorCode,
    fabric: interiorColorCode,
    packages: packageCodes || [],
    accessories: accessoryCodes || []
  };
  function getFuelType() {
    return query.fuelType || Array.isArray(selectedModel == null ? void 0 : selectedModel.keyFeatures) ? selectedModel == null ? void 0 : selectedModel.keyFeatures[1] : undefined;
  }
  if (query.datasetName) {
    variables.datasetName = query.datasetName;
  }
  return variables;
}
function getTotalSelection(selection) {
  if (selection === void 0) {
    selection = {};
  }
  var count = function count(key) {
    if (Array.isArray(selection[key])) {
      return selection[key].length;
    }
    return selection[key] ? 1 : 0;
  };
  return Object.keys(selection).reduce(function (total, key) {
    return total + count(key);
  }, 0);
}
function getTaxesAndFeesSelection(formData) {
  return (0, _pick2["default"])(formData, _constants.rebatesAndTaxesKeys);
}
function getTotalTaxesAndFeesSelectedByCalculation(formData, calculation) {
  var selection = getTaxesAndFeesSelection(formData);
  // Because `rebates` are sent globally, we need to count only
  // the ones that are available by calculation
  selection.rebates = (0, _intersection2["default"])(selection.rebates, calculation.rebateCodes);
  return getTotalSelection(selection);
}
function toDisplayValue(value) {
  return value ? formatPrice(value) : _constants.DEFAULT_DISPLAY_VALUE;
}
function isRebateApplicable(rebateCode, rebatesList) {
  if (!Array.isArray(rebatesList)) return false;
  return rebatesList.some(function (item) {
    return item.code === rebateCode;
  });
}
function parseGQLData(data, contentPageData, formData) {
  var _out$leaseAnnualMilea;
  if (!data) {
    return {};
  }
  var out = _objectSpread(_objectSpread({}, contentPageData), data.getPaymentCalculation);
  if (contentPageData != null && contentPageData.hasModelsOrdering) {
    out.vehicles = [].concat(contentPageData.vehicles).sort(function (a, b) {
      return Number(a.sortOrder) - Number(b.sortOrder);
    });
  }
  var mergeDataSources = function mergeDataSources(key) {
    return _objectSpread(_objectSpread({}, contentPageData[key]), data.getPaymentCalculation[key]);
  };

  // Common
  out.minimumLoanAllowance = Number(out.minimumLoanAllowance);

  // Lease
  out.leaseCalculation = mergeDataSources('leaseCalculation');
  out.leaseSelectedPaymentFrequency = formData.leasePaymentFrequency || out.leasePaymentFrequency[0].value;
  out.leaseTerms = out.leaseCalculation.terms;
  out.leaseDefaultTerm = getDefaultValue(out.leaseTerms);
  var selectedLeaseTerm = formData.leaseTerm || out.leaseDefaultTerm;
  out.leaseCalculation.rebates = getRebatesByCalculationType('Lease', selectedLeaseTerm);
  out.leaseCalculation.rebateCodes = getRebateCodes(out.leaseCalculation.rebates);
  out.leaseAnnualMileageTermMap = getAnnualMileageTermMap();
  out.leaseAnnualMileageOptions = (_out$leaseAnnualMilea = out.leaseAnnualMileageTermMap) == null || (_out$leaseAnnualMilea = _out$leaseAnnualMilea[selectedLeaseTerm]) == null ? void 0 : _out$leaseAnnualMilea.listPaymentResidualMileage;
  out.leaseDefaultAnnualMileage = getDefaultValue(out.leaseAnnualMileageOptions);
  out.leaseDefaultRate = formData.interestRate || out.leaseCalculation.interestRate ? out.leaseCalculation.interestRate.displayValue : '0%';
  out.leaseCalculation = _objectSpread(_objectSpread({}, out.leaseCalculation), getLeasePaymentDetails(formData.includeFee));

  // Finance
  out.financeCalculation = mergeDataSources('financeCalculation');
  out.financeSelectedPaymentFrequency = formData.financePaymentFrequency || out.financePaymentFrequency[0].value;
  out.financeCalculation.rebates = getRebatesByCalculationType('Finance');
  out.financeCalculation.rebateCodes = getRebateCodes(out.financeCalculation.rebates);
  out.financeTerms = parseTerms(out.financeCalculation.terms);
  out.financeDefaultTerm = getDefaultValue(out.financeTerms);
  out.financeDefaultRate = out.financeDefaultRate || out.financeCalculation.interestRate;
  out.financeCalculation = _objectSpread(_objectSpread({}, out.financeCalculation), getFinancePaymentDetails(formData.includeFee));

  // Cash
  out.cashCalculation = mergeDataSources('cashCalculation');
  out.cashCalculation.rebates = getRebatesByCalculationType('Cash');
  out.cashCalculation.rebateCodes = getRebateCodes(out.cashCalculation.rebates);
  out.cashCalculation = _objectSpread(_objectSpread({}, out.cashCalculation), getCashPaymentDetails(formData.includeFee));

  // Utils
  function getRebateCodes(rebates) {
    return rebates.map(function (rebate) {
      return rebate.code;
    });
  }
  function modelsFeesToLabels(modelFees, includeFee) {
    var filterFeeMap = ['Freight & PDI', 'Lease Administration fee'];
    var feesToLabels = modelFees.map(function (fee) {
      return {
        label: fee.feeName,
        value: fee.feeAmount.displayValue
      };
    });
    return includeFee ? feesToLabels : feesToLabels.filter(function (fee) {
      var returnFee = false;
      filterFeeMap.forEach(function (filterFee) {
        if (filterFee === fee.label) returnFee = true;
      });
      return returnFee;
    });
  }
  function taxesToLabels(taxes) {
    return (taxes == null ? void 0 : taxes.length) && taxes.map(function (tax) {
      return {
        label: tax.taxName,
        value: tax.taxValue.displayValue
      };
    });
  }
  function toLabelValue(label, value, themeStyle) {
    return {
      label: label,
      value: value,
      themeStyle: themeStyle
    };
  }
  function getRebatesByCalculationType(type, selectedLeaseTerm) {
    if (selectedLeaseTerm === void 0) {
      selectedLeaseTerm = null;
    }
    var total = function total(rebate) {
      return rebate.pretax ? "(" + formatPrice(rebate.pretax) + ")" : '';
    };

    // `rebates` are called `incentives` in the API.
    // Renaming for consistency
    return (0, _filter2["default"])(out.incentives, function (rebate) {
      var _rebate$leaseTerm;
      return (0, _includes2["default"])(rebate.shownOnBP, type) && (type !== 'Lease' || rebate.leaseTerm === null || ((_rebate$leaseTerm = rebate.leaseTerm) == null ? void 0 : _rebate$leaseTerm.length) <= 0 || (0, _includes2["default"])(rebate.leaseTerm, selectedLeaseTerm));
    }).map(function (rebate) {
      return _objectSpread(_objectSpread({}, rebate), {}, {
        label: rebate.name + " " + total(rebate)
      });
    });
  }
  function getAnnualMileageTermMap() {
    var annualMileageTermMap = out.leaseTerms.reduce(function (map, item) {
      var _objectSpread2;
      return _objectSpread(_objectSpread({}, map), {}, (_objectSpread2 = {}, _objectSpread2[item.value] = _objectSpread(_objectSpread({}, item), {}, {
        // Parse mileage selecting default values
        listPaymentResidualMileage: item.listPaymentResidualMileage.map(function (option, index) {
          return _objectSpread(_objectSpread({}, option), {}, {
            "default": index === 0,
            value: option.mileage
          });
        })
        // Sort the mileage options ASC
        .sort(function (a, b) {
          return Number(a.value) - Number(b.value);
        })
      }), _objectSpread2));
    }, {});
    return annualMileageTermMap;
  }
  function getLeasePaymentDetails(includeFee) {
    var _out$leaseAnnualMilea2, _out$leaseCalculation, _out$leaseCalculation2, _out$leaseCalculation3, _out$leaseCalculation4, _out$leaseCalculation5, _paymentDetails$total, _selectedTerm$ppsaReg, _selectedTerm$saleTax, _paymentDetails$total2;
    var amount = (0, _get2["default"])(out.leaseCalculation, 'paymentAmount.value');
    if (amount) {
      return out.leaseCalculation.paymentAmount;
    }
    var selectedMileage = formData.leaseAnnualMileage || out.leaseDefaultAnnualMileage;
    var selectedTerm = out.leaseAnnualMileageTermMap[selectedLeaseTerm];
    var paymentDetails = ((_out$leaseAnnualMilea2 = out.leaseAnnualMileageOptions) == null ? void 0 : _out$leaseAnnualMilea2.length) && out.leaseAnnualMileageOptions.find(function (_ref3) {
      var mileage = _ref3.mileage;
      return mileage === selectedMileage;
    });
    return _objectSpread(_objectSpread({
      value: 0
    }, paymentDetails), {}, {
      breakdown: [
      // Total selling price
      {
        title: out.totalSellingPriceSectionTitle,
        details: [toLabelValue(out.priceConfigLabel, out.leaseCalculation.modelPrice.displayValue), toLabelValue(out.optionsLabel, out.leaseCalculation.optionsPrice.displayValue)].concat(modelsFeesToLabels(out.leaseCalculation.modelFees, includeFee), [toLabelValue(out.breakdownTradeInLabel, "-" + out.leaseCalculation.tradeInValue.displayValue), toLabelValue(out.totalSellingPriceSectionTitle, out.leaseCalculation.totalSellingPrice.displayValue, 'tableRowMedium')])
      },
      // Total payable
      {
        title: out.totalPayableSectionTitle,
        details: [toLabelValue(out.effectiveInterestRateLabel, (_out$leaseCalculation = out.leaseCalculation) == null || (_out$leaseCalculation = _out$leaseCalculation.interestRate) == null ? void 0 : _out$leaseCalculation.displayValue), toLabelValue(out.endValueLabel, paymentDetails == null ? void 0 : paymentDetails.residualDisplayValue)].concat(taxesToLabels(paymentDetails == null ? void 0 : paymentDetails.taxes), [toLabelValue(out.rebatesLabel, "-" + ((_out$leaseCalculation2 = out.leaseCalculation) == null || (_out$leaseCalculation2 = _out$leaseCalculation2.rebatesPrice) == null ? void 0 : _out$leaseCalculation2.displayValue)), isRebateApplicable(_constants.rebateCodes.PROVINCIAL_EV_REBATE, out.leaseCalculation.rebates) && toLabelValue(out.provisionalEvRebateLabel, "-" + ((_out$leaseCalculation3 = out.leaseCalculation) == null || (_out$leaseCalculation3 = _out$leaseCalculation3.provinicalRebatePrice) == null ? void 0 : _out$leaseCalculation3.displayValue)), isRebateApplicable(_constants.rebateCodes.FEDERAL_EV_REBATE, out.leaseCalculation.rebates) && toLabelValue(out.federalEvRebateLabel, "-" + ((_out$leaseCalculation4 = out.leaseCalculation) == null || (_out$leaseCalculation4 = _out$leaseCalculation4.federalRebatePrice) == null ? void 0 : _out$leaseCalculation4.displayValue)), toLabelValue(out.customerRebateLabel, "-" + ((_out$leaseCalculation5 = out.leaseCalculation) == null || (_out$leaseCalculation5 = _out$leaseCalculation5.customerRebate) == null ? void 0 : _out$leaseCalculation5.displayValue)), toLabelValue(out.downPaymentLabel, "-" + toDisplayValue(formData.downPaymentAmount)), toLabelValue(getSelectedPaymentFrequencyLabel(out.leaseSelectedPaymentFrequency, out.leasePaymentFrequency), paymentDetails == null ? void 0 : paymentDetails.monthlyPaymentDisplayValue), toLabelValue(out.totalPayableSectionTitle, paymentDetails == null || (_paymentDetails$total = paymentDetails.totalPayable) == null ? void 0 : _paymentDetails$total.displayValue, 'tableRowMedium')])
      },
      // Due on delivery
      {
        title: out.totalDueOnDeliverySectionTitle,
        details: [toLabelValue(out.ppsaARegistration, selectedTerm == null || (_selectedTerm$ppsaReg = selectedTerm.ppsaRegistration) == null ? void 0 : _selectedTerm$ppsaReg.displayValue), toLabelValue(out.salesTaxDueOnDeliveryLabel, selectedTerm == null || (_selectedTerm$saleTax = selectedTerm.saleTaxDueOnDelivery) == null ? void 0 : _selectedTerm$saleTax.displayValue), toLabelValue(out.paymentLabel, paymentDetails == null ? void 0 : paymentDetails.monthlyPaymentDisplayValue), toLabelValue(out.totalDueOnDeliveryLabel, paymentDetails == null || (_paymentDetails$total2 = paymentDetails.totalDueOnDelivery) == null ? void 0 : _paymentDetails$total2.displayValue, 'tableRowMedium')]
      }]
    });
  }
  function getFinancePaymentDetails(includeFee) {
    var _out$financeTerms, _out$financeCalculati, _out$financeCalculati2, _paymentDetails$costO, _paymentDetails$costO2;
    var selectedTerm = formData.financeTerm || out.financeDefaultTerm;
    var paymentDetails = ((_out$financeTerms = out.financeTerms) == null ? void 0 : _out$financeTerms.length) && out.financeTerms.find(function (term) {
      return term.value === selectedTerm;
    });
    return _objectSpread(_objectSpread({
      value: 0
    }, paymentDetails), {}, {
      breakdown: [
      // Total selling price
      {
        title: out.totalSellingPriceSectionTitle,
        details: [toLabelValue(out.priceConfigLabel, out.financeCalculation.modelPrice.displayValue), toLabelValue(out.optionsLabel, out.financeCalculation.optionsPrice.displayValue)].concat(modelsFeesToLabels(out.financeCalculation.modelFees, includeFee), [toLabelValue(out.breakdownTradeInLabel, "-" + out.leaseCalculation.tradeInValue.displayValue), toLabelValue(out.subTotalLabel, out.financeCalculation.subTotal.displayValue, 'tableRowMedium')], taxesToLabels(out.financeCalculation.taxes), [toLabelValue(out.totalSellingPriceSectionTitle, out.financeCalculation.totalSellingPrice.displayValue, 'tableRowMedium')])
      },
      // Cost of summary
      {
        title: out.costSummarySectionTitle,
        details: [toLabelValue(out.effectiveInterestRateLabel, out.financeCalculation.interestRate.displayValue), toLabelValue(out.rebatesLabel, "-" + out.financeCalculation.rebatesPrice.displayValue), isRebateApplicable(_constants.rebateCodes.PROVINCIAL_EV_REBATE, out.financeCalculation.rebates) && toLabelValue(out.provisionalEvRebateLabel, "-" + ((_out$financeCalculati = out.financeCalculation) == null || (_out$financeCalculati = _out$financeCalculati.provinicalRebatePrice) == null ? void 0 : _out$financeCalculati.displayValue)), isRebateApplicable(_constants.rebateCodes.FEDERAL_EV_REBATE, out.financeCalculation.rebates) && toLabelValue(out.federalEvRebateLabel, "-" + ((_out$financeCalculati2 = out.financeCalculation) == null || (_out$financeCalculati2 = _out$financeCalculati2.federalRebatePrice) == null ? void 0 : _out$financeCalculati2.displayValue)), toLabelValue(out.customerRebateLabel, "-" + out.financeCalculation.customerRebate.displayValue), toLabelValue(out.downPaymentLabel, "-" + toDisplayValue(formData.downPaymentAmount)), toLabelValue(out.totalPurchaseLabel, out.financeCalculation.totalPurchasePrice.displayValue), toLabelValue(getSelectedPaymentFrequencyLabel(out.financeSelectedPaymentFrequency, out.financePaymentFrequency), paymentDetails == null ? void 0 : paymentDetails.monthlyPaymentDisplayValue), toLabelValue(out.firstPaymentLabel, toDisplayValue(paymentDetails == null ? void 0 : paymentDetails.firstPaymentValue)), toLabelValue(out.totalDueOnDeliveryLabel, out.financeCalculation.totalDueOnDelivery.displayValue), toLabelValue(out.costOfBorrowingLabel, paymentDetails == null || (_paymentDetails$costO = paymentDetails.costOfBorrowing) == null ? void 0 : _paymentDetails$costO.displayValue), toLabelValue(out.interestPayableLabel, paymentDetails == null || (_paymentDetails$costO2 = paymentDetails.costOfBorrowing) == null ? void 0 : _paymentDetails$costO2.displayValue)]
      }]
    });
  }
  function getCashPaymentDetails(includeFee) {
    var _out$cashCalculation, _out$cashCalculation2;
    return {
      breakdown: [
      // Total selling price
      {
        title: out.totalSellingPriceSectionTitle,
        details: [toLabelValue(out.priceConfigLabel, out.cashCalculation.modelPrice.displayValue), toLabelValue(out.optionsLabel, out.cashCalculation.optionsPrice.displayValue)].concat(modelsFeesToLabels(out.cashCalculation.modelFees, includeFee), [toLabelValue(out.breakdownTradeInLabel, "-" + out.cashCalculation.tradeInValue.displayValue), toLabelValue(out.totalSellingPriceSectionTitle, out.cashCalculation.totalSellingPrice.displayValue, 'tableRowMedium')])
      },
      // Taxes and rebates
      {
        title: out.taxAndRebatesSectionTitle,
        details: [].concat(taxesToLabels(out.cashCalculation.taxes), [toLabelValue(out.rebatesLabel, "-" + out.cashCalculation.rebatesPrice.displayValue), isRebateApplicable(_constants.rebateCodes.PROVINCIAL_EV_REBATE, out.cashCalculation.rebates) && toLabelValue(out.provisionalEvRebateLabel, "-" + ((_out$cashCalculation = out.cashCalculation) == null || (_out$cashCalculation = _out$cashCalculation.provinicalRebatePrice) == null ? void 0 : _out$cashCalculation.displayValue)), isRebateApplicable(_constants.rebateCodes.FEDERAL_EV_REBATE, out.cashCalculation.rebates) && toLabelValue(out.federalEvRebateLabel, "-" + ((_out$cashCalculation2 = out.cashCalculation) == null || (_out$cashCalculation2 = _out$cashCalculation2.federalRebatePrice) == null ? void 0 : _out$cashCalculation2.displayValue)), toLabelValue(out.customerRebateLabel, "-" + out.cashCalculation.customerRebate.displayValue), toLabelValue(out.totalTaxAndRebatesLabel, out.cashCalculation.totalTaxesRAndRebates.displayValue, 'tableRowMedium')])
      },
      // Total payment
      {
        title: out.paymentLabel,
        details: [toLabelValue(out.paymentLabel, out.cashCalculation.paymentAmount.displayValue)]
      }]
    };
  }
  return out;
}
function getSelectedPaymentFrequencyLabel(targetValue, options) {
  var _options$find;
  return (_options$find = options.find(function (option) {
    return option.value === targetValue;
  })) == null ? void 0 : _options$find.label;
}
function getCachedSelectModelAndTab() {
  return {
    selectedModelIndex: Number(_jsCookie["default"].get(_constants.vehicleKeyMap.SELECTED_MODEL_INDEX)) || 0,
    selectedTab: Number(_jsCookie["default"].get(_constants.vehicleKeyMap.SELECTED_TAB_INDEX)) || 0
  };
}

/**
 * getExtraLinks
 * @param {Object} options
 * @returns {Object | false}
 */
function getExtraLinks(_ref4) {
  var small = _ref4.small,
    hasLinks = _ref4.hasLinks,
    isNgc = _ref4.isNgc,
    data = _ref4.data,
    calculation = _ref4.calculation,
    combinedStepsLabels = _ref4.combinedStepsLabels;
  if (small && !hasLinks) {
    return false;
  }
  if (isNgc) {
    return _objectSpread(_objectSpread({}, data), deriveExtraLinks(calculation, combinedStepsLabels));
  }
  return data;
}
function isTradeInKey(key) {
  return _constants.tradeInKeys.includes(key);
}
function isDownPaymentKey(key) {
  return _constants.downPaymentKeys.includes(key);
}
function getComponentPageDataByResourceType(data, resourceType) {
  return data.ContentPage.components.find(function (component) {
    return component.resourceType === resourceType;
  });
}